import React from 'react'
import FooterOWRB from '../assets/OWRB.png'
import FooterFNI from '../assets/FNI Logo - White - RGB.png'

export default function Footer() {
    return (
        <div>
            <footer className="subfooter mt-4 py-3">
                <div className="container center-block">
                    <div className="row">
                        <div className="col-12 text-center">
                            <a href="https://www.owrb.ok.gov/" target="_blank"><img src={FooterOWRB} height="105" width="200"/></a>
                        </div>

                    </div>
                </div>
            </footer>
            <footer className="footer mt-auto py-3" style={{backgroundColor:"#2C3E50"}}>
                <div className="container text-light text-white">
                    <div className="row">
                        <div className="col-12 col-lg-2">
                            <p className=""><a href="https://www.freese.com/" target="_blank"><img
                                src={FooterFNI} style={{maxHeight:"90px"}}/></a></p>
                        </div>
                        <div className="col-12 col-lg-8" style={{textAlign:"center", color:"white"}}>
                            <p>&nbsp; © 2020 Freese and Nichols, Inc. | <a className="text-light text-white" target="_blank"
                                href="https://www.owrb.ok.gov/">Oklahoma Water Resources Board</a></p>
                        </div>
                        <div className="col-12 col-lg-2">
                            <p className=""><a href="#" className=" text-light text-white">Back to top</a></p>
                        </div>
                    </div>
                </div>
            </footer>

        </div>
    )
}
